import * as CallFrameApplet from '../callFrameApplet';
import * as ModalApplet from '../modalApplet';
import * as ConfigApplet from '../configApplet';
import * as HeadlessApplet from '../headlessApplet';
import * as PageApplet from '../pageApplet';
import * as OverlayApplet from '../overlayApplet';
import * as PostCallApplet from '../postCallApplet';
import * as DashboardApplet from '../dashboardApplet';
export type Constraints =
  | CallFrameApplet.Constraints
  | ModalApplet.Constraints
  | ConfigApplet.Constraints
  | HeadlessApplet.Constraints
  | PageApplet.Constraints
  | OverlayApplet.Constraints
  | PostCallApplet.Constraints
  | DashboardApplet.Constraints;

export const CapabilityIDs = [
  CallFrameApplet.id,
  ModalApplet.id,
  ConfigApplet.id,
  HeadlessApplet.id,
  PageApplet.id,
  OverlayApplet.id,
  PostCallApplet.id,
  DashboardApplet.id,
];
